const startViewTransition = async ({ callback, backTransition }) => {
    // Check if the document and startViewTransition function are available
    if (typeof window !== "undefined" && window.document && document.startViewTransition) {
        try {
            if (backTransition) {
                // Add a CSS class to indicate a back transition
                document.documentElement.classList.add("back-transition");

                // Start the transition
                const transition = document.startViewTransition(() => {
                    // Call the callback function during the transition
                    callback();
                });

                // Wait for the transition to finish
                await transition.finished;
            } else {
                // Start a regular transition without the CSS class
                document.startViewTransition(() => {
                    callback();
                });
            }
        } finally {
            if (backTransition) {
                // Remove the CSS class after a back transition
                document.documentElement.classList.remove("back-transition");
            }
        }
    } else {
        // Fallback: If startViewTransition is not available, call the callback directly
        callback();
    }
};

export default startViewTransition;

